import { Component, EventEmitter, Output, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'ew-button-help',
  templateUrl: './button-help.component.html',
  styleUrls: ['./button-help.component.scss'],
})
export class ButtonHelpComponent {
  @Input() url: string = 'https://help.edvisor.io/edwallet/what-is-edwallet';
  @Output() reload: EventEmitter<any> = new EventEmitter();
  open: boolean = false;

  src!: SafeResourceUrl;

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.src = this.domSanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
